module.exports = __webpack_public_path__ + "static/img/banner4.1821809b.svg";